/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react"
import {createFragmentContainer} from "react-relay";
import {graphql} from "babel-plugin-relay/macro";
import {
    NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural$data
} from "ui/feature/root/note-select/__generated__/NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural.graphql";
import styles from "./NoteFinderPageOverlaySharpFlatNatural.module.scss";
import ReactTooltip from "react-tooltip";

interface Props {
    sharpFlatNatural: NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural$data;
    pageWidth: number;
    pageHeight: number;
}

const NoteFinderPageOverlaySharpFlatNatural: React.FC<Props> = ({pageWidth, pageHeight, sharpFlatNatural}) => {

    const width = React.useMemo(() => {
        return `${(sharpFlatNatural.width / pageWidth) * 100}%`;
    }, [sharpFlatNatural.width, pageWidth])

    const height = React.useMemo(() => {
        return `${(sharpFlatNatural.height / pageHeight) * 100}%`;
    }, [sharpFlatNatural.height, pageHeight]);

    const left = React.useMemo(() => {
        return `${(sharpFlatNatural.x / pageWidth) * 100}%`;
    }, [sharpFlatNatural.x, pageWidth]);

    const top = React.useMemo(() => {
        return `${(sharpFlatNatural.y / pageHeight) * 100}%`;
    }, [sharpFlatNatural.y, pageHeight]);

    const tooltipName = `${sharpFlatNatural.id}-tooltip`;

    const onClick = React.useCallback(() => {
        console.group(`sharp_flat_natural id=${sharpFlatNatural.id}`);
        console.log(`id=${sharpFlatNatural.id}`);
        console.log(`type=${sharpFlatNatural.type}`);
        console.log(`placement=${sharpFlatNatural.placement}`)
        console.log(`x=${sharpFlatNatural.x}, y=${sharpFlatNatural.y}, width=${sharpFlatNatural.width}, height=${sharpFlatNatural.height}`)
        console.groupEnd();
    }, [sharpFlatNatural]);

    return (
        <>
            <ReactTooltip place={"top"} type={"light"} effect={"solid"} id={tooltipName}>
                <p className={styles.tooltipContent}>{sharpFlatNatural.type}</p>
                <p className={styles.tooltipContent}>Confidence: {sharpFlatNatural.finder_confidence}</p>
            </ReactTooltip>
            <div
                className={styles.container}
                data-tip
                data-for={tooltipName}
                onClick={onClick}
                style={{
                    width: width,
                    height: height,
                    left: left,
                    top: top
                }}/>
        </>
    );
}

export default createFragmentContainer(
    NoteFinderPageOverlaySharpFlatNatural,
    {
        sharpFlatNatural: graphql`
        fragment NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural on MusicParseStepDataNoteDataSourceCombineSharpFlatNatural {
            id
            x
            y
            width
            height
            type
            finder_confidence
            placement
        }
        `
    }
)